import {Card, Col} from 'reactstrap';

import {CDN_IMAGE_URL} from 'configs';
import urljoin from 'url-join';
import local from './Stakeholder.module.scss';
import cx from 'classnames';

function getIconLink(name) {
  return urljoin(CDN_IMAGE_URL, name);
}

export default function CardColumn(props) {
  const {list, start = 0, end, className} = props;
  const slice = end !== undefined ? list.slice(start, end) : list.slice(start);

  return (
    <Col xs={12} lg={4} className={cx(className)}>
      {slice.map((letter, index) => (
        <Card className="mb-3 mb-mb-5" key={`col1-${index}`}>
          <div className="p-4">
            <div className={local['letters__logo-container']}>
              <img
                src={getIconLink(letter.img.toString())}
                alt={letter.company.props.children[0]}
                className={cx(local['letters__logo'])}
                style={letter.css}
                loading="lazy"
                fetchpriority="low"
                decoding="async"
                width="90px"
                height="auto"
              />
            </div>
            <div className="mb-5">{letter.content}</div>
            {letter.company}
          </div>
        </Card>
      ))}
    </Col>
  );
}
